import React, { useState, useEffect, useRef } from 'react';
import './events.css';
import PageHeader from "../../layouts/home/PageHeader";
import { Container, Row, Col } from "react-bootstrap";
import PosterCard from "../../components/accesories/card/PosterCard";
import {useData} from "../../context/DataContext";
import useHandleRequest from "../../custom_hooks/useHandleRequest";

function Events(props) {

    const [posters, setPosters] = useState([]);
    const {data, fetchData, loading} = useData();
    const {handleRequestAndNavigate} = useHandleRequest();
    const [category, setCategory] = useState('all');
    const [filteredPosters, setFilteredPosters] = useState(posters);
    const [isTransitioning, setIsTransitioning] = useState(false); // وضعیت برای انیمیشن

    // برای استفاده از تایمینگ انیمیشن
    const transitionTimeout = useRef(null);

     /*= useState([
        { id: 1, status: 0, header: 'برگزاری دوره پایتون پیشرفته', date: '۲۹ ماه پیش', img: '/images/poster-1.jpg' },
        { id: 2, status: 1, header: 'برگزاری دوره پایتون پیشرفته', date: '۲۹ ماه پیش', img: '/images/poster-2.jpg' },
        { id: 3, status: 0, header: 'برگزاری دوره پایتون پیشرفته', date: '۲۹ ماه پیش', img: '/images/poster-3.jpg' },
        { id: 4, status: 1, header: 'برگزاری دوره پایتون پیشرفته', date: '۲۹ ماه پیش', img: '/images/poster-4.jpg' }
    ]);*/

    useEffect(() => {
        if (data.events.length === 0) {  // چک می‌کنیم که آرایه خالی نباشد
            fetchData("events", "events/");
        } else {
            setPosters(data.events);
        }
    }, [data.events]); // وابسته به `data.blogs`


    // فیلتر کردن پوسترها وقتی که دسته‌بندی تغییر می‌کند
    useEffect(() => {
        // زمانی که دسته‌بندی تغییر می‌کند، کارت‌ها به مدت 500 میلی‌ثانیه مخفی می‌شوند
        setIsTransitioning(true); // کارت‌ها در حال مخفی شدن هستند

        // پاک کردن تایم‌اوت قبلی (در صورت وجود)
        if (transitionTimeout.current) {
            clearTimeout(transitionTimeout.current);
        }

        // زمان‌بندی انیمیشن تغییر دسته‌بندی
        transitionTimeout.current = setTimeout(() => {
            // بعد از مخفی شدن، کارت‌ها را فیلتر کرده و به‌روز رسانی می‌کنیم
            const updatedPosters = posters.filter(poster => {
                if (category === 'all') return true;
                if (category === 'done') return poster.status;
                return !poster.status;
            });
            setFilteredPosters(updatedPosters); // به‌روزرسانی لیست کارت‌ها

            // پس از فیلتر کردن، کارت‌ها را به نمایش در می‌آوریم با یک تاخیر
            setTimeout(() => {
                setIsTransitioning(false); // انیمیشن پایان یافت و کارت‌ها ظاهر می‌شوند
            }, 150); // تأخیر کوتاه برای نمایش کارت‌ها
        }, 180); // مدت زمان انیمیشن مخفی شدن کارت‌ها

        // پاک کردن تایم‌اوت در صورت رندر مجدد
        return () => {
            if (transitionTimeout.current) {
                clearTimeout(transitionTimeout.current);
            }
        };

    }, [category, posters]); // هر بار که دسته‌بندی تغییر کند، انیمیشن شروع می‌شود

    const changeCategory = (status) => {
        // فقط زمانی که دسته‌بندی تغییر کند، انیمیشن اجرا شود
        if (status !== category) {
            setCategory(status); // تغییر دسته‌بندی
        }
    };

    return (
        <>
            <section>
                <PageHeader mainTitle={'حواست به رویدادهای ما باشه'} currentPage={'رویدادها'}
                            navigationLinks={[{ title: 'صفحه اصلی', href: '/' }]} />
            </section>
            <section>
                <Container className={'events-content-wrapper'}>
                    <Row className={'text-center mb-3 m-md-5'}>
                        <Col className={'category-col d-flex flex-column align-items-center justify-content-center'}>
                            <div className={'mb-2 button-wrapper gap-0 gap-md-2 events-category d-flex align-items-center justify-content-center'}>
                                <button onClick={() => changeCategory('all')} className={category === 'all' && 'active'}>همه</button>
                                <button onClick={() => changeCategory('doing')} className={category === 'doing' && 'active'}>رویدادهای آینده</button>
                                <button onClick={() => changeCategory('done')} className={category === 'done' && 'active'}>برگزار شده</button>
                            </div>
                            <div className={'events-underline'} />
                        </Col>
                    </Row>
                    <Row>
                        {filteredPosters.map(filteredPoster => (
                            <Col sm={12} md={6} xl={4} className={`p-xxl-5 p-xl-4 p-lg-5 p-md-4 p-sm-5 p-5 card-col ${isTransitioning ? 'hide' : 'show'}`}
                                 key={filteredPoster.id}>
                                <PosterCard
                                    to={`${filteredPoster.status ? '/finished_event/' + filteredPoster.id : '/event/' + filteredPoster.id}`}
                                    header={filteredPoster.title}
                                    date={filteredPoster.event_date}
                                    statusText={`${filteredPoster.status ? 'برگزار شده' : 'برگزاری در آینده'}`}
                                    statusColor={`${filteredPoster.status ? 'red' : 'green'}`}
                                    posterImg={filteredPoster.image}
                                />
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default Events;
